module.exports = __webpack_public_path__ + "static/media/interview-with-mr-satish-ramchandani.166c7c86.webp";